import { takeLatest } from 'redux-saga/effects';
import { TYPES } from '../constants';
import loadTenantsSaga from './loadTenantsSaga';
import createTenantSaga from './createTenantSaga';
import loadTenantSaga from './loadTenantSaga';
import updateTenant from './updateTenantSaga';
import deleteTenantSaga from './deleteTenantSaga';
import loadTenantAdminsSaga from './loadTenantAdminsSaga';
import deleteTenantAdminSaga from './deleteTenantAdminSaga';
import inviteTenantAdminsSaga from './inviteTenantAdminSaga';
import resendInviteTenantAdminSaga from './resendInviteTenantAdminSaga';
import loadTenantAdminDataSaga from './getTenantAdminData';
import registerTenantAdminSaga from './registerTenantAdmin';
import loadStorm360AdminsSaga from './loadStorm360Admins';
import setTenantUserStatusSaga from './setTenantUserStatusSaga';
import inviteTenantUserSaga from './inviteTenantUserSaga';
import inviteSharedUserSaga from './inviteSharedUserSaga';
import registerTenantUserSaga from './registerTenantUserSaga';
import loadTenantPendingUsersSaga from './loadTenantPendingUsersSaga';
import resendInviteTenantUsersSaga from './resendInviteTenantUsersSaga';
import deletePendingTenantUserSaga from './deletePendingTenantUserSaga';
import loadStorm360UsersSaga from './loadStorm360UsersSaga';
import inviteStorm360AdminSaga from './inviteStorm360AdminSaga';
import loadPendingStorm360AdminsSaga from './loadPendingStorm360AdminsSaga';
import deletePendingStorm360AdminsSaga from './deletePendingStorm360AdminsSaga';
import resendInviteStorm360AdminSaga from './resendInviteStorm360AdminSaga';
import loadTenantsForSharedUserSaga from './loadTenantForSharedUserSaga';
import acceptTenantInviteSaga from './acceptTenantInviteSaga';
import loadTenantUsersListSaga from './loadTenantUsersListSaga';
import tenantLogoUploadSaga from './tenantLogoUploadSaga';
import deleteTenantLogoSaga from './deleteTenantLogoSaga';

export default function* tenantsSagas(): Generator {
  yield takeLatest(TYPES.LOAD_TENANTS.INIT, loadTenantsSaga);
  yield takeLatest(TYPES.CREATE_TENANT.INIT, createTenantSaga);
  yield takeLatest(TYPES.LOAD_TENANT.INIT, loadTenantSaga);
  yield takeLatest(TYPES.UPDATE_TENANT.INIT, updateTenant);
  yield takeLatest(TYPES.DELETE_TENANT.INIT, deleteTenantSaga);
  yield takeLatest(TYPES.LOAD_TENANT_ADMINS.INIT, loadTenantAdminsSaga);
  yield takeLatest(TYPES.DELETE_TENANT_ADMIN.INIT, deleteTenantAdminSaga);
  yield takeLatest(TYPES.INVITE_TENANT_ADMIN.INIT, inviteTenantAdminsSaga);
  yield takeLatest(TYPES.RESEND_INVITE_TENANT_ADMIN.INIT, resendInviteTenantAdminSaga);
  yield takeLatest(TYPES.LOAD_TENANT_ADMIN_DATA.INIT, loadTenantAdminDataSaga);
  yield takeLatest(TYPES.REGISTER_TENANT_ADMIN.INIT, registerTenantAdminSaga);
  yield takeLatest(TYPES.LOAD_STORM360_USERS.INIT, loadStorm360UsersSaga);
  yield takeLatest(TYPES.LOAD_STORM360_ADMINS.INIT, loadStorm360AdminsSaga);
  yield takeLatest(TYPES.INVITE_STORM360_ADMIN.INIT, inviteStorm360AdminSaga);
  yield takeLatest(TYPES.SET_TENANT_USER_STATUS.INIT, setTenantUserStatusSaga);
  yield takeLatest(TYPES.INVITE_TENANT_USER.INIT, inviteTenantUserSaga);
  yield takeLatest(TYPES.INVITE_SHARED_USER.INIT, inviteSharedUserSaga);
  yield takeLatest(TYPES.REGISTER_TENANT_USER.INIT, registerTenantUserSaga);
  yield takeLatest(TYPES.LOAD_TENANT_PENDING_USERS.INIT, loadTenantPendingUsersSaga);
  yield takeLatest(TYPES.RESEND_INVITE_TENANT_USERS.INIT, resendInviteTenantUsersSaga);
  yield takeLatest(TYPES.DELETE_PENDING_TENANT_USERS.INIT, deletePendingTenantUserSaga);
  yield takeLatest(TYPES.LOAD_PENDING_STORM360_ADMINS.INIT, loadPendingStorm360AdminsSaga);
  yield takeLatest(TYPES.DELETE_PENDING_STORM360_ADMINS.INIT, deletePendingStorm360AdminsSaga);
  yield takeLatest(TYPES.RESEND_INVITE_STORM360_ADMIN.INIT, resendInviteStorm360AdminSaga);
  yield takeLatest(TYPES.LOAD_TENANTS_FOR_SHARED_USER.INIT, loadTenantsForSharedUserSaga);
  yield takeLatest(TYPES.ACCEPT_TENANT_INVITE.INIT, acceptTenantInviteSaga);
  yield takeLatest(TYPES.LOAD_TENANT_USERS_LIST.INIT, loadTenantUsersListSaga);
  yield takeLatest(TYPES.UPLOAD_TENANT_LOGO.INIT, tenantLogoUploadSaga);
  yield takeLatest(TYPES.DELETE_TENANT_LOGO.INIT, deleteTenantLogoSaga);
}
